// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"467":"a1d5574b","488":"d2a81a9f","821":"85eb1652"}[chunkId] + ".chunk.js";
};